<template>
  <div class="contacts">
    <div
      v-if="intro"
      class="grid-wrap contacts__intro">
      <p class="bold grid--lg-50 ">
        {{ intro }}
      </p>
    </div>
    <div class="grid-wrap">
      <div
        v-if="heading || logo"
        class="grid--lg-50 bold">
        <div class="contacts__logos">
          <h4
            v-if="heading"
            class="grey bold ucase">
            {{ heading }}
          </h4>
        </div>
      </div>
      <div
        v-if="content"
        class="grid--lg-50 bold">
        <div class="contacts__list ">
          <div
            v-for="(contact, contactKey) in content"
            :key="contactKey"
            class="contact">
            <p class="ucase">
              {{ contact.name }}
            </p>
            <p>
              {{ contact.role }}
            </p>
            <p>
              {{ contact.phone }}
            </p>
            <p>
              <a
                :href="`mailto:${contact.email}`">
                {{ contact.email }}
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="grid--lg-50">
        <ImageBlock
          v-if="logo"
          :content="logo" />
      </div>
    </div>
    <div
      v-if="footer"
      class="grid-wrap contacts__footer">
      <div class="grid--lg-50">
        <p class="bold ">
          {{ footer }}
        </p>
        <ImageBlock
          v-if="secLogo"
          :is-left="true"
          :content="secLogo" />
      </div>
    </div>
  </div>
</template>

<script>
import ImageBlock from '@/components/sections/types/ImageBlock'

export default {
  name: 'Contacts',
  components: {
    ImageBlock
  },
  props: {
    intro: {
      type: String,
      default: ''
    },
    heading: {
      type: String,
      default: ''
    },
    content: {
      type: Array,
      default: null
    },
    logo: {
      type: Object,
      default: null
    },
    footer: {
      type: String,
      default: null
    },
    secLogo: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.contacts {
  &__intro {
    padding: $padding--base 0;

    p {
      margin-left: auto;
    }

    @include mobile {
      padding: $gutter--base 0 0;
    }
  }

  &__list {
    @include section;

    img {
      display: none;
    }

    @include mobile {
      padding: 0;

      img {
        margin: 0 0 $padding--base-mbl 0;
        display: block;
      }
    }

    .contact {
      width: 100%;
      margin-bottom: $padding--base-mbl;

      a {
        color: $color--white;
      }
    }
  }

  &__logos {
    @include section;
    height: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;

    h4 {
      margin-bottom: auto;
    }
  }

  &__footer {
    padding: $padding--base 0;

    .grid--lg-50 {
      flex-direction: column;
      align-items: flex-start;
      margin-left: auto;
    }

    p {
      margin-bottom: $gutter--base;
    }

    @include mobile {
      padding: $gutter--base 0 0;
    }
  }
}
</style>

<style lang="scss">
  .contacts__logos {
    img {
      margin: $padding--base-mbl 0;

      @include mobile {
        margin-bottom: 0;
        display: none;
      }
    }
  }
</style>
